import type { CustomerStore } from './interfaces'

export const actions = {
  setCustomer (this: CustomerStore, payload: CustomerStore['customer']): void {
    this.customer = payload
  },
  resetCustomer (this: CustomerStore): void {
    this.customer = null
  },
}